<template>
  <div class="searchBox">
    <input
      type="text"
      v-model="scanCode"
      @keyup.enter="onSubmit"
      placeholder="请扫码"
    />
    <img src="../assets/home/barcode-read.png" @click="wxScan()" />
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      scanCode: this.code,
    };
  },
  components: {
    [Toast.name]: Toast,
  },
  methods: {
    onSubmit() {
      if (this.scanCode.indexOf("ly_HnwLEAV9_rUb893qF/") > -1) {
        this.scanCode = this.scanCode.split("ly_HnwLEAV9_rUb893qF/")[1];
        this.$emit("subCode", this.scanCode);
      } else {
        var reg = /^\d{1,}$/;
        var pattern = new RegExp(reg);
        if (pattern.test(this.scanCode)) {
          if (this.scanCode.length === 10) {
            this.$emit("subCode", this.scanCode);
          } else {
            Toast("所扫码不符合规范");
            this.scanCode = "";
          }
        } else {
          Toast("所扫码不符合规范");
          this.scanCode = "";
        }
      }
    },
    wxScan() {
      var _this = this;
      this.wx.checkJsApi({
        jsApiList: ["scanQRCode"],
        success: function (res) {
          console.log(res);
        },
      });
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          _this.scanCode = result;
          _this.onSubmit();
        },
      });
    },
  },
  watch: {
    code: function (val) {
      this.scanCode = val;
    },
  },
  created() {
    var dd = {
      url: location.href.split("#")[0],
    };
    this.$get("/WechatOAuthAPI/WechatSign", dd)
      .then((res) => {
        if (!res.IsError) {
          this.wx.config({
            debug: false,
            appId: res.Data.AppId,
            timestamp: res.Data.Timestamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.Signature,
            jsApiList: ["scanQRCode"],
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  name: "TopBar",
  props: {
    code: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.searchBox {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: white;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;

  width: 355px;
  z-index: 99;
}
.searchBox img {
  width: 32px;
  flex-shrink: 0;
  height: 32px;
  margin-left: 20px;
}
.searchBox input {
  width: 100%;
  height: 38px;
  border: none;
  box-shadow: 0 0 5px 0 #eee;
  font-size: 12px;
  text-indent: 6px;
}
</style>
